<script lang="ts">
  import clsx from 'clsx'

  import { fade } from 'svelte/transition'
  import componentAttributesStore from '../../../stores/componentAttributes.svelte'
  import videoStore from '../../../stores/video.svelte'
  import withPreventDefault from '../../../utils/withPreventDefault'
  import { THEMES } from '../../../const/themes'

  type Props = {
    children?: () => any
  }
  const { children }: Props = $props()

  let div: HTMLDivElement | null = $state(null)
  let contentHeight = 0
  let hasScrollBar = $state(false)

  function adjustParentHeight() {
    if (!div) {
      return
    }

    const activeChildDiv = div.querySelector(`ul`)

    if (!activeChildDiv) {
      return
    }

    const maxHeight =
      (videoStore.state.containerElement?.offsetHeight || 0) - 100
    const newHeight = activeChildDiv.scrollHeight
    if (newHeight !== contentHeight) {
      contentHeight = newHeight
      hasScrollBar = contentHeight > maxHeight
      div.style.transition = 'height 0.1s ease'
      div.style.height = `${Math.min(maxHeight, contentHeight)}px`
    }
  }

  $effect(() => {
    if (div) {
      const update = () =>
        setTimeout(() => {
          adjustParentHeight()
        })

      new MutationObserver(() => {
        update()
      }).observe(div, { childList: true, subtree: true })

      update()
    }
  })
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
  bind:this={div}
  onclick={withPreventDefault}
  class={clsx(
    hasScrollBar &&
      'overflow-y-scroll scrollbar-thin  scrollbar-thumb-rounded-full scrollbar-track-rounded-full  scrollbar-thumb-slate-500/70 scrollbar-track-slate-800/40',
    'mobile:h-full mobile:top-8 mobile:right-2 cursor-default',
    'pb-2 z-50 absolute text-white bottom-[56px] right-[15px] rounded text-left text-sm min-w-60 h-fit flex overflow-hidden [&>ul>li]:my-2',
    {
      'bg-black': !videoStore.state.isPicureInPictureSupported,
      'bg-black/60': videoStore.state.isPicureInPictureSupported,
    },
  )}
  style="fill: {componentAttributesStore.state.buttonsColor ||
    THEMES.DEFAULT.BUTTONS_COLOR};"
  in:fade={{ duration: 120 }}
>
  {@render children?.()}
</div>
